
define('C25.BlogList.View'
	, [
		'CustomContentType.Base.View'
		, 'C25.Blog.Model'
		, 'c25_bloglist.tpl'

		, 'jQuery'
		, 'underscore'

		, 'Tools'
	]
	, function (
		CustomContentTypeBaseView
		, Model
		, c25_bloglist_tpl

		, jQuery
		, _

		, Tools
	) {
		'use strict';

		return CustomContentTypeBaseView.extend({

			template: c25_bloglist_tpl
			,
			initialize: function () {
				var self = this;
				this.model = new Model();

				this.model
					.fetch({ data: {} })
					.done(function (res) {
						self.posts = res || [];
						// for (var i = 0; i < 30; i++) {
						// 	self.posts.push(self.posts[0]);
						// }
						self.render();
					}).catch(function (err) {
						console.error(err.responseJSON); //GT Code 25 - search for error
					});;

			}
			, getContext: function getContext() {

				this.settings.highlights = [];
				this.settings.posts = [];
				var latest = parseInt(this.settings.custrecord_c25_bloglist_showlatest || "3");
				this.settings.highlightsCol = "blogpost_list";
				// if (latest == 3) {
				// 	this.settings.highlightsCol = "col-xs-12 col-sm-4";
				// }
				// if (latest == 6) {
				// 	this.settings.highlightsCol = "col-xs-12 col-sm-4 col-md-2 col-lg-2";
				// }

				if (this.posts) {
					for (var i = 0; i < this.posts.length; i++) {
						if (this.posts[i].summary && this.posts[i].summary.length > 150) {
							this.posts[i].summary = this.posts[i].summary.substring(0, 150) + "...";
						}
						if (i < latest) {
							this.settings.highlights.push(this.posts[i]);
						} else {
							this.settings.posts.push(this.posts[i]);
						}
					}

					this.settings.showPosts = latest > 0;


				}
				this.settings.hasHighlights = this.settings.highlights.length > 0;
				this.settings.hasPosts = this.settings.custrecord_c25_bloglist_showothers=="T"&&this.settings.posts.length > 0;
				//console.log("settings b", this.settings);
				return this.settings;
			}
		});
	});
